import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import MapUrbanisme from '@/components/maps/MapUrbanisme';
import RiskGrid from '@/components/maps/RiskGrid';
import {
  TYPE_DPU_OPTIONS,
  RISQUES_INTERIEURS_OPTIONS,
  ZONE_SISMICITE_OPTIONS,
  ZONAGE_PPR_OPTIONS,
} from '@/constants/enums';

export default function SectionUrbanisme({ data, onChange, cartesUrbanisme, allCartesUrbanisme, risquesRapport, gpuData }) {
  const val = (field) => field.split('.').reduce((obj, key) => obj?.[key], data) ?? '';
  const handleChange = (field) => (e) => onChange(field, e.target.value);
  const handleCheck = (field) => (e) => onChange(field, e.target.checked);

  return (
    <div className="space-y-8">
      {/* ════════════════════════════════════════════ */}
      {/* Urbanisme & Risques                         */}
      {/* ════════════════════════════════════════════ */}

      {/* Permis de construire */}
      <section className="space-y-4">
        <h3 className="text-lg font-semibold text-slate-800">Permis de construire</h3>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('urbanisme_risques.pc_communique')}
            onChange={handleCheck('urbanisme_risques.pc_communique')}
            className="rounded border-slate-300"
          />
          PC communiqué
        </label>

        {val('urbanisme_risques.pc_communique') && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Input
              label="Numéro PC"
              name="urbanisme_risques.pc_numero"
              value={val('urbanisme_risques.pc_numero')}
              onChange={handleChange('urbanisme_risques.pc_numero')}
            />
            <Input
              label="Date PC"
              name="urbanisme_risques.pc_date"
              type="date"
              value={val('urbanisme_risques.pc_date')}
              onChange={handleChange('urbanisme_risques.pc_date')}
            />
            <Input
              label="DAACT"
              name="urbanisme_risques.daact_date"
              type="date"
              value={val('urbanisme_risques.daact_date')}
              onChange={handleChange('urbanisme_risques.daact_date')}
            />
            <Input
              label="Conformité"
              name="urbanisme_risques.conformite_date"
              type="date"
              value={val('urbanisme_risques.conformite_date')}
              onChange={handleChange('urbanisme_risques.conformite_date')}
            />
          </div>
        )}
      </section>

      {/* Servitudes publiques */}
      <section className="space-y-4">
        <h3 className="text-lg font-semibold text-slate-800">Servitudes publiques</h3>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('urbanisme_risques.dpu')}
            onChange={handleCheck('urbanisme_risques.dpu')}
            className="rounded border-slate-300"
          />
          DPU
        </label>

        {val('urbanisme_risques.dpu') && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <Select
              label="Type de DPU"
              name="urbanisme_risques.dpu_type"
              value={val('urbanisme_risques.dpu_type')}
              options={TYPE_DPU_OPTIONS}
              onChange={handleChange('urbanisme_risques.dpu_type')}
            />
          </div>
        )}

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('urbanisme_risques.monuments_historiques')}
            onChange={handleCheck('urbanisme_risques.monuments_historiques')}
            className="rounded border-slate-300"
          />
          Monuments historiques
        </label>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('urbanisme_risques.zone_inondable')}
            onChange={handleCheck('urbanisme_risques.zone_inondable')}
            className="rounded border-slate-300"
          />
          Zone inondable
        </label>

        {val('urbanisme_risques.zone_inondable') && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Type de zone inondable"
              name="urbanisme_risques.zone_inondable_type"
              value={val('urbanisme_risques.zone_inondable_type')}
              onChange={handleChange('urbanisme_risques.zone_inondable_type')}
            />
          </div>
        )}

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('urbanisme_risques.zone_bruit')}
            onChange={handleCheck('urbanisme_risques.zone_bruit')}
            className="rounded border-slate-300"
          />
          Zone de bruit
        </label>

        {val('urbanisme_risques.zone_bruit') && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Source du bruit"
              name="urbanisme_risques.zone_bruit_source"
              value={val('urbanisme_risques.zone_bruit_source')}
              onChange={handleChange('urbanisme_risques.zone_bruit_source')}
            />
          </div>
        )}
      </section>

      {/* PLU */}
      <section className="space-y-4">
        <h3 className="text-lg font-semibold text-slate-800">PLU</h3>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={val('urbanisme_risques.plu_existe') !== false && val('urbanisme_risques.plu_existe') !== ''}
            onChange={handleCheck('urbanisme_risques.plu_existe')}
            className="rounded border-slate-300"
          />
          PLU existant
        </label>

        {(val('urbanisme_risques.plu_existe') !== false && val('urbanisme_risques.plu_existe') !== '') && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Règlement"
              name="urbanisme_risques.plu_reglement"
              value={val('urbanisme_risques.plu_reglement')}
              onChange={handleChange('urbanisme_risques.plu_reglement')}
            />
            <Input
              label="Zonage"
              name="urbanisme_risques.plu_zonage"
              value={val('urbanisme_risques.plu_zonage')}
              onChange={handleChange('urbanisme_risques.plu_zonage')}
            />
            <Input
              label="Destination"
              name="urbanisme_risques.plu_destination"
              value={val('urbanisme_risques.plu_destination')}
              onChange={handleChange('urbanisme_risques.plu_destination')}
            />
            <Input
              label="Prescriptions"
              name="urbanisme_risques.plu_prescriptions"
              type="textarea"
              value={val('urbanisme_risques.plu_prescriptions')}
              onChange={handleChange('urbanisme_risques.plu_prescriptions')}
            />
          </div>
        )}

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('urbanisme_risques.reconstruction_identique')}
            onChange={handleCheck('urbanisme_risques.reconstruction_identique')}
            className="rounded border-slate-300"
          />
          Reconstruction à l'identique possible
        </label>
      </section>

      {/* Risques */}
      <section className="space-y-4">
        <h3 className="text-lg font-semibold text-slate-800">Risques</h3>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('urbanisme_risques.risques_environnementaux')}
            onChange={handleCheck('urbanisme_risques.risques_environnementaux')}
            className="rounded border-slate-300"
          />
          Risques environnementaux
        </label>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            label="Risques intérieurs"
            name="urbanisme_risques.risques_interieurs"
            value={val('urbanisme_risques.risques_interieurs')}
            options={RISQUES_INTERIEURS_OPTIONS}
            onChange={handleChange('urbanisme_risques.risques_interieurs')}
          />
          <Select
            label="Zone de sismicité"
            name="urbanisme_risques.zone_sismicite"
            value={val('urbanisme_risques.zone_sismicite')}
            options={ZONE_SISMICITE_OPTIONS}
            onChange={handleChange('urbanisme_risques.zone_sismicite')}
          />
        </div>
      </section>

      {/* PPR Naturel */}
      <section className="space-y-4">
        <h3 className="text-lg font-semibold text-slate-800">PPR Naturel</h3>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('urbanisme_risques.pprn.concerne')}
            onChange={handleCheck('urbanisme_risques.pprn.concerne')}
            className="rounded border-slate-300"
          />
          Concerné par PPRN
        </label>

        {val('urbanisme_risques.pprn.concerne') && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
              label="Date d'approbation"
              name="urbanisme_risques.pprn.date_approbation"
              type="date"
              value={val('urbanisme_risques.pprn.date_approbation')}
              onChange={handleChange('urbanisme_risques.pprn.date_approbation')}
            />
            <Input
              label="Nature du risque"
              name="urbanisme_risques.pprn.nature_risque"
              value={val('urbanisme_risques.pprn.nature_risque')}
              onChange={handleChange('urbanisme_risques.pprn.nature_risque')}
            />
            <Select
              label="Zonage"
              name="urbanisme_risques.pprn.zonage"
              value={val('urbanisme_risques.pprn.zonage')}
              options={ZONAGE_PPR_OPTIONS}
              onChange={handleChange('urbanisme_risques.pprn.zonage')}
            />
          </div>
        )}
      </section>

      {/* PPR Technologique */}
      <section className="space-y-4">
        <h3 className="text-lg font-semibold text-slate-800">PPR Technologique</h3>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('urbanisme_risques.pprt.concerne')}
            onChange={handleCheck('urbanisme_risques.pprt.concerne')}
            className="rounded border-slate-300"
          />
          Concerné par PPRT
        </label>

        {val('urbanisme_risques.pprt.concerne') && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
              label="Date d'approbation"
              name="urbanisme_risques.pprt.date_approbation"
              type="date"
              value={val('urbanisme_risques.pprt.date_approbation')}
              onChange={handleChange('urbanisme_risques.pprt.date_approbation')}
            />
            <Input
              label="Nature du risque"
              name="urbanisme_risques.pprt.nature_risque"
              value={val('urbanisme_risques.pprt.nature_risque')}
              onChange={handleChange('urbanisme_risques.pprt.nature_risque')}
            />
            <Select
              label="Zonage"
              name="urbanisme_risques.pprt.zonage"
              value={val('urbanisme_risques.pprt.zonage')}
              options={ZONAGE_PPR_OPTIONS}
              onChange={handleChange('urbanisme_risques.pprt.zonage')}
            />
          </div>
        )}
      </section>

      {/* Impact urbanisme sur la valorisation */}
      <div>
        <Input
          label="Impact urbanisme sur la valorisation"
          name="urbanisme_risques.impact_urbanisme_valorisation"
          type="textarea"
          value={val('urbanisme_risques.impact_urbanisme_valorisation')}
          onChange={handleChange('urbanisme_risques.impact_urbanisme_valorisation')}
        />
      </div>

      {/* Données GPU récupérées (lecture seule, autofill via /geo/reglementation) */}
      {gpuData && (
        (gpuData.prescriptions_lineaires?.length > 0
          || gpuData.prescriptions_ponctuelles?.length > 0
          || gpuData.servitudes_actes?.length > 0) && (
          <div className="rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm space-y-3">
            <h4 className="font-semibold text-slate-800">Données GPU récupérées</h4>

            {gpuData.prescriptions_lineaires?.length > 0 && (
              <div>
                <p className="font-medium text-slate-700">Prescriptions linéaires</p>
                <ul className="list-disc pl-5 text-slate-700">
                  {gpuData.prescriptions_lineaires.map((p, i) => (
                    <li key={i}>{p.libelle}</li>
                  ))}
                </ul>
              </div>
            )}

            {gpuData.prescriptions_ponctuelles?.length > 0 && (
              <div>
                <p className="font-medium text-slate-700">Prescriptions ponctuelles</p>
                <ul className="list-disc pl-5 text-slate-700">
                  {gpuData.prescriptions_ponctuelles.map((p, i) => (
                    <li key={i}>{p.libelle}</li>
                  ))}
                </ul>
              </div>
            )}

            {gpuData.servitudes_actes?.length > 0 && (
              <div>
                <p className="font-medium text-slate-700">Actes des servitudes</p>
                <ul className="list-disc pl-5 text-slate-700">
                  {gpuData.servitudes_actes.map((a, i) => (
                    <li key={i}>
                      {a.type_acte}
                      {a.date_acte ? ` du ${a.date_acte}` : ''}
                      {a.servitude ? ` — ${a.servitude}` : ''}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )
      )}

      {/* ════════════════════════════════════════════ */}
      {/* Cartes statiques (générées côté backend) */}
      {cartesUrbanisme && (
        <section className="space-y-4">
          <h3 className="text-lg font-semibold text-slate-800">Carte PLU</h3>
          <MapUrbanisme imageUrl={cartesUrbanisme.plu} />
          <h3 className="text-lg font-semibold text-slate-800">Cartes des risques</h3>
          <RiskGrid cartes={cartesUrbanisme} risquesRapport={risquesRapport} />

          {allCartesUrbanisme && allCartesUrbanisme.length > 1 && (
            <details className="mt-4">
              <summary className="text-sm font-medium text-slate-600 cursor-pointer hover:text-slate-800">
                Cartes des autres parcelles ({allCartesUrbanisme.length - 1})
              </summary>
              <div className="mt-2 space-y-4">
                {allCartesUrbanisme.slice(1).map((cartes, idx) => (
                  <div key={idx} className="border border-slate-200 rounded-lg p-3">
                    <p className="text-xs font-medium text-slate-500 mb-2">Parcelle {idx + 2}</p>
                    <RiskGrid cartes={cartes} risquesRapport={risquesRapport} />
                  </div>
                ))}
              </div>
            </details>
          )}
        </section>
      )}

      {/* Performance énergétique                     */}
      {/* ════════════════════════════════════════════ */}

      <section className="space-y-4">
        <h3 className="text-lg font-semibold text-slate-800">Performance énergétique</h3>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('performance_energetique.dpe_disponible')}
            onChange={handleCheck('performance_energetique.dpe_disponible')}
            className="rounded border-slate-300"
          />
          DPE disponible
        </label>

        {val('performance_energetique.dpe_disponible') && (
          <div className="pl-6 space-y-4">
            <Input
              label="Résultat DPE"
              name="performance_energetique.dpe_resultat"
              value={val('performance_energetique.dpe_resultat')}
              onChange={handleChange('performance_energetique.dpe_resultat')}
              placeholder="ex: Classe D — 180 kWh/m²/an"
            />
            <Input
              label="Impact DPE"
              name="performance_energetique.dpe_impact"
              type="textarea"
              value={val('performance_energetique.dpe_impact')}
              onChange={handleChange('performance_energetique.dpe_impact')}
            />
          </div>
        )}

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!val('performance_energetique.amiante_disponible')}
            onChange={handleCheck('performance_energetique.amiante_disponible')}
            className="rounded border-slate-300"
          />
          Diagnostic amiante disponible
        </label>

        {val('performance_energetique.amiante_disponible') && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Date de repérage"
              name="performance_energetique.amiante_date_reperage"
              type="date"
              value={val('performance_energetique.amiante_date_reperage')}
              onChange={handleChange('performance_energetique.amiante_date_reperage')}
            />
            <Input
              label="Opérateur"
              name="performance_energetique.amiante_operateur"
              value={val('performance_energetique.amiante_operateur')}
              onChange={handleChange('performance_energetique.amiante_operateur')}
            />
            <Input
              label="Résultats"
              name="performance_energetique.amiante_resultats"
              type="textarea"
              value={val('performance_energetique.amiante_resultats')}
              onChange={handleChange('performance_energetique.amiante_resultats')}
            />
            <Input
              label="Impact amiante"
              name="performance_energetique.amiante_impact"
              type="textarea"
              value={val('performance_energetique.amiante_impact')}
              onChange={handleChange('performance_energetique.amiante_impact')}
            />
          </div>
        )}
      </section>
    </div>
  );
}
